/* eslint-disable import/no-unresolved */
import 'javascripts/portal_used_model_v2/privacy_policy';
import 'stylesheets/portal_used_model_v2/privacy_policy';
